var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"img_box"},[_c('a',{staticClass:"logo",attrs:{"href":""}},[_c('img',{attrs:{"src":_vm.urlImg +_vm.logo}})])]),_c('div',{staticClass:"title"},[_vm._v("需求发布全流程信息系统")]),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }